import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { tap, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { DkForbiddenComponent } from '@/app/shared/components/dk-forbidden/dk-forbidden.component';

interface ApiResponse<T = any> {
  isSuccess: boolean;
  statusCode: number;
  result: T | null;
  errors: any[];
  version: string; 
  environment: string;
}

// Placeholder service for 403 dialog integration.
// Replace the method body with your actual pop-up implementation.
// Deprecated placeholder left for compatibility in case of imports; use the service in ../services.

let isForbiddenDialogOpen = false;

export const ForbiddenInterceptor: HttpInterceptorFn = (req, next) => {
  const dialogService = inject(DialogService);
  const handle401Error = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.reload();
  }

  const handle403Error = () => {
    if (!isForbiddenDialogOpen) {
      isForbiddenDialogOpen = true;
      const ref = dialogService.open(DkForbiddenComponent, {
        modal: true,
        closable: true,
        dismissableMask: true,
        data: {},
      });
      ref.onClose.subscribe(() => {
        isForbiddenDialogOpen = false;
      });
    }
  }

  return next(req).pipe(
    tap((event) => {
      if (!(event instanceof HttpResponse)) return;
      if (event.body && typeof event.body === 'object' && !(event.body instanceof Blob)) {
        const body: any = event.body as any;
        if (Object.prototype.hasOwnProperty.call(body, 'statusCode')) {
          const apiBody = body as ApiResponse;

          if (apiBody.statusCode === 401) {
            handle401Error();
          } else if (apiBody.statusCode === 403) {
            handle403Error();
          }
        }
      }

      if (event.body instanceof Blob) {
        const reader = new FileReader();
        reader.onload = () => {
          try {
            const text = reader.result as string;
            const parsed = JSON.parse(text) as Partial<ApiResponse>;
            if (parsed && typeof parsed === 'object') {
              if (parsed.statusCode === 401) {
                handle401Error();
              } else if (parsed.statusCode === 403) {
                handle403Error();
              }
            }
          } catch {
            // Not JSON; ignore
          }
        };
        reader.readAsText(event.body);
      }
    }),
    catchError((error) => {
      if (error instanceof HttpErrorResponse) {
        if (error.status === 401) {
          handle401Error();
        } else if (error.status === 403) {
          handle403Error();
        }
      }
      return throwError(() => error);
    })
  );
};